import { render, staticRenderFns } from "./InteresHistoricoSimpleTable.vue?vue&type=template&id=0dacea5b&scoped=true"
import script from "./InteresHistoricoSimpleTable.vue?vue&type=script&lang=js"
export * from "./InteresHistoricoSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dacea5b",
  null
  
)

export default component.exports